let worker;
let seq = 0;
const jobs = new Map();

const ensureWorker = () => {
	if (worker) return worker;
	worker = new Worker(new URL("./parseUpload.worker.js", import.meta.url));
	worker.onmessage = (event) => {
		const message = event.data || {};
		const job = jobs.get(message.id);
		if (!job) return;
		if (message.type === "done" || message.type === "payload") {
			jobs.delete(message.id);
			job.resolve(message);
			return;
		}
		if (message.type === "error") {
			jobs.delete(message.id);
			job.reject(new Error(message.message || "Failed to read file"));
		}
	};
	worker.onerror = (event) => {
		const message = event?.message || "Failed to read file";
		jobs.forEach((job) => job.reject(new Error(message)));
		jobs.clear();
	};
	return worker;
};

const track = (id, handlers) =>
	new Promise((resolve, reject) => {
		jobs.set(id, { ...handlers, resolve, reject });
	});

export const startFileParse = (buffer, columns) => {
	const id = ++seq;
	const promise = track(id, {});
	ensureWorker().postMessage({ type: "parse", id, buffer, columns }, [buffer]);
	return { id, promise };
};

export const buildUploadPayload = (storeId, uploadType) => {
	const id = ++seq;
	const promise = track(id, {});
	ensureWorker().postMessage({ type: "payload", id, storeId, uploadType });
	return promise.then((message) => message.buffer);
};

export const releaseParsedFile = (storeId) => {
	if (!storeId || !worker) return;
	worker.postMessage({ type: "release", storeId });
};
